import React, { Fragment } from 'react';
import moment from 'moment-timezone';
import { WIDGET_LOCALE } from '../../locale-wrapper';
import cn from 'classnames';
import styles from './style.scss';
import { List } from 'immutable';

export const EventOccurrences = ({ event, settings }) => {
  const dateTBD = event.get('date_tbd');
  if (dateTBD) return <span />;

  const timeZone = settings.get('automaticTimezone') ? moment.tz.guess() : event.getIn(['date', 'start', 'timezone']);

  const locale = event.get('type') === 'eventviewer' ? WIDGET_LOCALE : event.get('locale', 'en').split('_')[0];

  return (
    <UpcomingEvents
      upcomingEvents={event.get('upcoming_occurrences')}
      settings={settings}
      timeZone={timeZone}
      locale={locale}
      dateFormat={settings.get('dateFormat')}
      timeFormat={settings.get('timeFormat')}
    />
  );
};

const getDateEvent = (event, dateFormat, timezone, locale) => {
  const startDate = moment.tz(event.get('start_date'), timezone).locale(locale);
  const endDate = moment.tz(event.get('end_date'), timezone).locale(locale);

  if (startDate.isSame(endDate, 'day')) {
    return startDate.format(dateFormat);
  }

  const startDateString = startDate.format(dateFormat);
  const endDateString = endDate.format(dateFormat);
  return `${startDateString} - ${endDateString}`;
};

// Extracts only the time portion
const getAppointTime = (event, timeFormat, timezone, locale) => {
  const startDate = moment.tz(event.get('start_date'), timezone).locale(locale);
  const endDate = moment.tz(event.get('end_date'), timezone).locale(locale);

  const startDateTimeString = startDate.format(timeFormat);
  const endDateTimeString = endDate.isValid() ? endDate.format(timeFormat) : null;

  return endDateTimeString ? `${startDateTimeString} - ${endDateTimeString}` : startDateTimeString;
};

const UpcomingEvents = ({ upcomingEvents, timeZone, locale, timeFormat, dateFormat }) => {
  const renderOccurrence = (occurrence) => {
    const date = getDateEvent(occurrence, dateFormat, timeZone, locale);
    const time = getAppointTime(occurrence, timeFormat, timeZone, locale);
    const timedEntries = occurrence.get('timed_entries') || List();
    return (
      <Fragment>
        <div className={cn('occurrence', styles.caption)}>
          <div className="date">{date}</div>
          {(!timedEntries.size || timedEntries.size === 0) && (
            <div className={styles.timeButton}>
              <span className="date-color">&#9679;</span> <div className="date">{time}</div>
            </div>
          )}
          <div className={cn('timed-entry-row', styles.timedEntryRow)}>
            {timedEntries.map((entry) => (
              <div className={cn('info-row', styles.infoRow)}>
                <div className={styles.timeButton}>
                  <span className="date-color">&#9679;</span> <div className="date">{getAppointTime(entry, timeFormat, timeZone, locale)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <div className={cn('upcoming-events', styles.upcomingEvents)}>
      <div className={cn('occurrence-wrapper', styles.occurrenceWrapper)}>
        {upcomingEvents.map((occurrence, index) => (
          <Fragment>
            {renderOccurrence(occurrence)}
            {index < upcomingEvents.length - 1 && <hr className={styles.separator} />}
          </Fragment>
        ))}
        {upcomingEvents.length > 3 && <div className={cn('occurrence', styles.caption)}>... and {upcomingEvents.length - 3} more dates</div>}
      </div>
    </div>
  );
};
